<template>
    <div>
        <div class="col-md-12" style="height: 100%;">
        <template >
            <div  class="formi539-header">
                <div class="row" style="padding-top: 15px; padding-bottom: 5px;">
                <div class="col-md-6">
                    <h3 class="header">FORM I-539</h3>
                </div>
            </div>
            </div>
        </template>
        <div style="margin-top:20px">
            <i539-summary :FormI539ListData="FormI539List" :consultantDetails="consultantDetails"></i539-summary>
        </div>
    </div>
    </div>
</template>
<script>
import I539Summary from "./I539Summary.vue"
export default {
    props:["FormI539List" ,"consultantDetails"],
    data(){
        return{
        }
    },
    components:{
        "i539-summary":I539Summary,
    },
    
}
</script>
<style lang="scss" scoped>
.header{
    margin: 0;
    display: inline-block;
    font-weight: 700;
    color: #143361;
    line-height: 30px;
}
.formi539-header
   {
    border-bottom: 1px dashed #ccc;
    padding-bottom: 10px;
   }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539/FolderList.vue